import { render, staticRenderFns } from "./AnnouncementsROAs.vue?vue&type=template&id=178d520f&scoped=true&"
import script from "./AnnouncementsROAs.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsROAs.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsROAs.vue?vue&type=style&index=0&id=178d520f&lang=scss&scoped=true&"
import style1 from "./AnnouncementsROAs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178d520f",
  null
  
)

export default component.exports